module.exports = __webpack_public_path__ + "static/img/ic-bind.cf505224.jpg";